/**
 * Custom React.memo comparator for SortableItem.
 *
 * Skips comparing expanded-only props when item is collapsed.
 * `flows` is always compared because it affects the flow-availability dots
 * and the preferred star rendered on every item (even when collapsed).
 */
export function sortableItemPropsEqual(
  prev: Record<string, any>,
  next: Record<string, any>
): boolean {
  // Always compare these core props (affect rendering in all states)
  if (
    prev.id !== next.id ||
    prev.item !== next.item ||
    prev.completing !== next.completing ||
    prev.isExpanded !== next.isExpanded ||
    prev.isRenaming !== next.isRenaming ||
    prev.onToggle !== next.onToggle ||
    prev.onToggleExpand !== next.onToggleExpand ||
    prev.onDelete !== next.onDelete ||
    prev.onStartRename !== next.onStartRename ||
    prev.onSubmitRename !== next.onSubmitRename ||
    prev.quantityDraft !== next.quantityDraft ||
    prev.onUpdateQuantityDraft !== next.onUpdateQuantityDraft ||
    prev.onSubmitQuantity !== next.onSubmitQuantity ||
    prev.isUnordered !== next.isUnordered ||
    prev.isSeparator !== next.isSeparator ||
    prev.isGhost !== next.isGhost ||
    prev.isHidden !== next.isHidden ||
    prev.justAdded !== next.justAdded ||
    prev.isFadingOut !== next.isFadingOut ||
    prev.flows !== next.flows || // Affects flow dots + preferred star on all items
    prev.selectedFlowId !== next.selectedFlowId // Affects preferred star in collapsed state
  ) {
    return false
  }

  // Only compare expanded-panel-only props when the item is (or was) expanded.
  if (prev.isExpanded || next.isExpanded) {
    if (
      prev.onToggleFlowAvailability !== next.onToggleFlowAvailability ||
      prev.onFlowPreferencesCommit !== next.onFlowPreferencesCommit
    ) {
      return false
    }
  }

  return true
}
